import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"border":"1px solid #ccc","margin-top":"10px"} }

import '@wangeditor/editor/dist/css/style.css';
  import { onBeforeUnmount, ref, shallowRef, watch } from 'vue';
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    value: { default: '' },
    disabled: { default: false }
  },
  emits: ['update:value', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { value: string, disabled: boolean }

  

  
  // 编辑器实例，必须用 shallowRef，重要！
  const editorRef = shallowRef();
  const valueHtml = ref('');
  const toolbarConfig = {
    toolbarKeys: ['bold', 'bulletedList', 'numberedList', 'undo', 'redo', 'fullScreen'],
  };
  const editorConfig = { placeholder: '请输入内容...' };

  // 组件销毁时，也及时销毁编辑器，重要！
  onBeforeUnmount(() => {
    const editor = editorRef.value;
    if (editor == null) return;

    editor.destroy();
  });

  // 编辑器回调函数
  const handleCreated = (editor) => {
    editorRef.value = editor; // 记录 editor 实例，重要！
  };
  const handleChange = (editor) => {
    let htmlContent = editor.getHtml();
    const converter = new window.showdown.Converter();
    htmlContent = converter.makeMarkdown(htmlContent);
    emit('update:value', htmlContent);
    emit('change', htmlContent);
  };

  const disable = () => {
    const editor = editorRef.value;
    if (editor == null) return;
    editor.disable();
  };
  const handleValue = () => {
    const converter = new window.showdown.Converter();
    valueHtml.value = converter.makeHtml(props.value);
  };
  handleValue();

  watch(
    () => props.disabled,
    (val) => {
      val && disable();
    }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Toolbar), {
        editor: _unref(editorRef),
        defaultConfig: toolbarConfig,
        mode: "default",
        style: {"border-bottom":"1px solid #ccc"}
      }, null, 8, ["editor"]),
      _createVNode(_unref(Editor), {
        defaultConfig: editorConfig,
        mode: "default",
        modelValue: valueHtml.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueHtml).value = $event)),
        style: {"height":"400px","overflow-y":"hidden"},
        onOnCreated: handleCreated,
        onOnChange: handleChange
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})